import { HttpError } from "@nasam/kernel";

/**
 * A refusal the API explains (400, 403, 404, 409: "POI already exists.")
 * keeps its own message; anything else -- no connection, a timeout, a 5xx --
 * becomes `failureMessage` (e.g. "Unable to create POI. Please try again.").
 */
export function requestError(error: unknown, failureMessage: string): unknown {
  const explained =
    error instanceof HttpError &&
    error.status !== undefined &&
    error.status >= 400 &&
    error.status < 500;
  return explained ? error : new Error(failureMessage, { cause: error });
}
